import Head from 'next/head'
import Link from 'next/link'
import { FC, Fragment, PropsWithChildren } from 'react'

import { AppLayout } from '@/components/Layouts/AppLayout'
import { useLanguage } from '@/hooks/Contexts'
//  'login' | 'register' | 'forget-password' | 'reset-password
const AuthLayout: FC<PropsWithChildren<{ type: number }>> = ({ type, children }) => {
  const { auth: authStr, navigation: navStr } = useLanguage()
  const heading = [authStr.login, authStr.register, authStr.find_account, authStr.reset_password, authStr.email_verification][type]
  return (
    <Fragment>
      <AppLayout innerCls='flex flex-col items-center'>
        {/* h1, not a div — these pages had no heading element at all. */}
        <h1 className='text-center text-xl font-bold capitalize md:text-2xl'>{heading}</h1>
        {children}
        {type > 2 ? null : (
          <div className='hidden lg:mt-6 lg:flex lg:justify-center lg:text-sm'>
            <span className='text-black'>{type == 1 ? authStr.have_account : authStr.no_account}</span>
            <Link href={type == 1 ? '/login' : '/register'}>
              <button className='ml-1 text-cyan-v2 hover:text-amber-v1'>{type == 1 ? authStr.login_now : authStr.register_now}</button>
            </Link>
          </div>
        )}
      </AppLayout>
      {type > 2 ? null : (
        <div className='container-white flex flex-col items-center justify-center bg-white/100 lg:hidden'>
          <span className='font-semibold text-black'>{type == 1 ? authStr.have_account : authStr.no_account}</span>
          <Link href={type == 1 ? '/login' : '/register'}>
            <button className='btn-rd-outline btn-hover-amber btn-disabled-grey mt-4 h-10 w-full max-w-sm'>
              {type == 1 ? authStr.login_now : authStr.register_now}
            </button>
          </Link>
        </div>
      )}

      {/* Must come after <AppLayout>: it renders its own <title>, and <title> has no key to
          dedupe on — Next simply keeps the last one rendered. */}
      <Head>
        <title>{`${heading} - ${navStr.app_name}`}</title>
        {/* No auth screen belongs in the index. /login alone was pulling 68,803 impressions
            as a brand sitelink while being useless to anyone not signed up. Same key as
            Navbar's robots tag so this overrides it. */}
        <meta name='robots' content='noindex, follow' key='robots' />
      </Head>
    </Fragment>
  )
}

export default AuthLayout
